import { FS } from '@dadohr/shared/versions';
import { Button, Grid } from '@material-ui/core';
import { capitalize } from 'lodash';
import React, { useState } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { Loader } from '../../../../../components/Loader';
import { SelectSimple } from '../../../../../components/SelectSimple';
import { CanvasBar } from '../../../../../layout/Canvas';
import { Centered } from '../../../../../layout/Centered';
import { Page } from '../../../../../layout/Page';
import { useTypedStringQueryParam } from '../../../../../routes';
import { store, useMappedLoadingValue } from '../../../../../services/firebase';
import { BuildMetadata } from '../../components/BuildMetadata';
import { DeploymentEnv, DEPLOYMENT_ENVS, toBuildDoc } from '../../service';

type Props = {};

const getBuildsQuery = (env: string, limit: number) =>
  store()
    .collection(FS._deploymentBuilds)
    .where('env', '==', env)
    .orderBy('startedAt', 'desc')
    .limit(limit);

const useBuilds = (env: DeploymentEnv, limit: number) => {
  return useMappedLoadingValue(useCollection(getBuildsQuery(env, limit)), (s) =>
    s.docs.map(toBuildDoc)
  );
};

const Builds: React.FC<{
  env: DeploymentEnv;
  setEnv: (nextEnv: DeploymentEnv) => void;
}> = ({ env, setEnv }) => {
  const [limit, setLimit] = useState(10);
  const [builds, loading] = useBuilds(env, limit);

  return (
    <>
      <CanvasBar>
        <SelectSimple
          selected={env}
          setSelected={setEnv}
          options={DEPLOYMENT_ENVS}
          toLabel={capitalize}
        />
      </CanvasBar>
      {loading && !builds && <Loader height={500} />}
      {builds && (
        <div>
          {builds.map((b) => (
            <BuildMetadata key={b.id} build={b.data} />
          ))}
          <Centered>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setLimit((l) => l + 10)}
            >
              Show more
            </Button>
          </Centered>
        </div>
      )}
    </>
  );
};

export const PageDeploymentBuilds: React.FC<Props> = () => {
  const [envLeft, setEnvLeft] = useTypedStringQueryParam<DeploymentEnv>(
    'left',
    'dev'
  );
  const [envRight, setEnvRight] = useTypedStringQueryParam<DeploymentEnv>(
    'right',
    'prod'
  );
  return (
    <Page>
      <Grid container alignItems="stretch" spacing={2}>
        <Grid item md={6} sm={12}>
          <Builds env={envLeft} setEnv={setEnvLeft} />
        </Grid>
        <Grid item md={6} sm={12}>
          <Builds env={envRight} setEnv={setEnvRight} />
        </Grid>
      </Grid>
    </Page>
  );
};
